import HeaderUserLogin from "Components/Header/HeaderTop/HeaderUserLogin/HeaderUserLogin";
import Loader from "Components/Loader/loader";
import { authenticateUser } from "Services/auth";
import { PropTypes } from "prop-types";
import React, { useEffect, useState } from "react";
import { RiBuildingLine } from "react-icons/ri";
import { connect } from "react-redux";
import Modal from "../Modal";
import AlumniUniversite from "../ModalCreationCompte/AlumniUniversite/AlumniUniversite";
import UspnUniversite from "./AlumniUniversite/UspnUniversite";

const ModalConnexion = (props) => {
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];
  const [loginVisible, setLoginVisible] = useState(false);
  const [clickedUniversityId, setClickedUniversityId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [clickedUniversity, setClickedUniversity] = useState(null);
  const [universities, setUniversities] = useState(null);
  const [creationCompteVisible, setCreationCompteVisible] = useState(false);
  const [uspnCompteVisible, setUspnCompteVisible] = useState(false);

  const displayLogin = () => setLoginVisible(true);
  const displayRegister = () => setCreationCompteVisible(true);
  const clickedUniversityProps = () => setClickedUniversity(null);

  useEffect(() => {
    props.universities?.universitiesData?.length > 0 &&
    setUniversities(
        props.universities.universitiesData.sort(() => Math.random() - 0.5)
    );
  }, []);

  return (
      <div>
        <Modal
            visible={props.visibleModal}
            setVisible={props.setVisibleModal}
            header="Se connecter"
        >
          <div className="modal_connection">
            <div className="modal_connection_left">
            <span>
              {" "}
              À quelle(s) université(s) souhaitez-vous être rattaché ?
            </span>
              <div className="modal_connection_university">
                {universities ? (
                    universities.map((university, index) =>
                        props.alumni ? (
                            ((university.slug === "pantheon-sorbonne" ||
                                university.slug === "upec" || university.slug === 'uspn') && (props.extraInfo === 'alumni' || props.extraInfo === 'student')) && (
                                <div
                                    key={index}
                                    className="modal_connection_university_button"
                                    onClick={() => {
                                      setClickedUniversityId(university.id);
                                      setClickedUniversity(university);
                                      if (university.slug === 'uspn' && props.extraInfo === "student") {
                                        window.location.href = "https://cas.univ-paris13.fr/cas/login?service=http%3A%2F%2Freseaupro.univ-paris13.fr%2Findex.php%2Fuser%2Flogin%3FloginCas%3Dcas"
                                      }
                                      authenticateUser(
                                          university,
                                          true,
                                          university.slug != 'uspn' ? displayRegister : displayLogin,
                                          props.alumni
                                      );
                                    }}
                                >
                                  <img
                                      src={
                                          API_LINK + university.imageTransparentAndColorUrl
                                      }
                                      alt="Logo_univ"
                                  />
                                </div>
                            )
                        ) : (
                            <div
                                key={index}
                                className="modal_connection_university_button"
                                onClick={() => {
                                  setClickedUniversityId(university.id);
                                  setClickedUniversity(university);
                                  if (university.slug === 'uspn') {
                                    setUspnCompteVisible(true);
                                    setLoginVisible(false);
                                    setCreationCompteVisible(true);
                                  }
                                  if (university.slug !== 'uspn') {
                                    authenticateUser(university, true, displayLogin);
                                  }
                                }}
                            >
                              <img
                                  src={API_LINK + university.imageTransparentAndColorUrl}
                                  alt="Logo_univ"
                              />
                            </div>
                        )
                    )
                ) : (
                    <Loader></Loader>
                )}
              </div>
            </div>
            { ! props.alumni && (
                <div className="modal_connection_right">
                  <div className="modal_connection_right_icon">
                    <RiBuildingLine></RiBuildingLine>
                  </div>
                  <div className="modal_connection_right_message">
                <span>
                  Cliquez ici, si vous êtes une entreprise ou un recruteur
                </span>
                  </div>

                  <button
                      className="modal_connection_right_button"
                      onClick={() =>
                          (window.location.href = `${process.env.REACT_APP_FRONT_ENTREPRISE}?login`)
                      }
                  >
                    Je suis une entreprise
                  </button>
                </div>
            )}
          </div>
        </Modal>

        {loginVisible && (
            <HeaderUserLogin
                loginVisible={loginVisible}
                setLoginVisible={setLoginVisible}
                setGlobalModalConnexion={props.setVisibleModal}
                universityId={clickedUniversityId}
            />
        )}
        {props.alumni && creationCompteVisible && (
            <Modal
                visible={creationCompteVisible}
                setVisible={setCreationCompteVisible}
                header="Alumni Université"
            >
              <div className="description">
                <AlumniUniversite
                    setVisibleUniv={setCreationCompteVisible}
                    setClickedUniversity={clickedUniversityProps}
                ></AlumniUniversite>
              </div>
            </Modal>
        )}
        {
            uspnCompteVisible && (
                <Modal
                    visible={uspnCompteVisible}
                    setVisible={setUspnCompteVisible}
                    header="CONNEXION"
                >
                  <div className="description">
                    <UspnUniversite
                        setVisibleUniv={setUspnCompteVisible}
                        setClickedUniversity={clickedUniversityProps}
                        uspn={true}
                    ></UspnUniversite>
                  </div>
                </Modal>
            )
        }
      </div>
  );
};

ModalConnexion.defaultProps = {
  alumni: false,
};

ModalConnexion.propTypes = {
  universities: PropTypes.object,
  alumni: PropTypes.bool, // Si à true : on affiche uniquement les universités qui gèrent les alumni (P1 / UPEC pour le moment) sinon on affiche toutes les universités
  visibleModal: PropTypes.bool,
  setVisibleModal: PropTypes.func,
  extraInfo: PropTypes.string
};

const mapStateToProps = (state) => ({
  universities: state.universities,
});

const mapDispatchToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(ModalConnexion);
